import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import Form from '../../../containers/Form/Form'
import Button from '../../../containers/Form/Button'

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_cam_models, tool_cam_model_save } from "../../../app/apiEndpoints"
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, FormControl, Breadcrumb, FormGroup } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'
import Select from '../../../containers/Form/Select'

import CardHeader from '../../../containers/CardHeader';
import { cleanUrl } from '../../../app/functions/cleanUrl';


const CamModelManagement = (props) => {
    const toolID = 23
    const [tool, setTool] = useState({})

    const paths = [{'ID': 2, 'NAME': "Stripchat"},{'ID': 5, 'NAME': "IMLive"}]
    const [path, setPath] = useState('')
    const [pathid, setPathid] = useState(0)

    // const [modelId, setModelId] = useState(0)
    const [model, setModel] = useState('')
    const [campaignId, setCampaignId] = useState('')
    const [modelImg, setModelImg] = useState('')

    const [formMessage, setFormMessage] = useState('')
    const [updating, setUpdating] = useState(false)
    const [processing, setProcessing] = useState(false)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [models, setModels] = useState([])


    const tableID = "model"
    const tableFields = ["Username", "Campaign ID", "Last Online", "Modified"]


    // const [dataChanged, setDataChanged] = useState(false)
    // const [showConfirm, setShowConfirm] = useState(false)

    useEffect(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_cam_models, { 'requester': userID, 'company': companyID, 'pathid': pathid })
                if(data.error) {
                    setFormMessage(data.error)
                } else {
                    setModels(data.models)
                }
            }
        }
        if(pathid > 0) {
            getDetails()
        }
    }, [userID,companyID,pathid])

    useEffect(() => {
        const performUpdate = async () => {
            setProcessing(true)
            const data = await toolsAPICall(tool_cam_model_save, { 'requester': userID, 'company': companyID, 'model': model, 'campaign_id': campaignId, 'pathid': pathid})
            if(data.error) {
                setFormMessage(data.error)
            } 
            else if(data.models) {
                setModels(data.models)
                setFormMessage("Model updated")
            }
            setUpdating(false)
            setProcessing(false)
        }
        
        if((campaignId).length > 0 && updating && !processing) {
            performUpdate()
        }
    }, [userID, companyID, model, campaignId, pathid, updating, processing])

    const tableData = () => {
        if(models.length === 0) {
            return [];
        } 
        //console.log('data', campaigns)
        let rows = [];
        models.forEach(row => {
            if(row.campaign_id.length > 0) {
                rows.push({'id': `${row.id}`, 'values': [
                    row.username,
                    row.campaign_id,
                    row.last_online,
                    row.modified_date
                ]});
            }
        });
        return rows
    }


    const addModel = (e) => {
        e.preventDefault()
        setFormMessage("")
        setCampaignId('')
        setModel('')
    }

    const viewModel = (e) => {
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        //look for the subpid in array
        let m = models.find((element) => {
            return element.id === rowID;
          })
        if(m === undefined) {
            return
        }
        setModel(m.username)
        setCampaignId(m.campaign_id)
    }

    const updateModel = (e) => {
        e.preventDefault()
        setFormMessage("")

        if(!model) {
            setFormMessage("Please select a Model")
            return
        }
        if(!campaignId) {
            setFormMessage("Please enter a Campaign ID")
            return
        }

        setUpdating(true)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name + " = " + value)
        if(name === "pathid") { 
            setPathid(value); 
            const foundPath = paths.find(item => item.ID === parseInt(value));
            if(foundPath) setPath(foundPath.NAME) 
        }
        else if(name === "model") { 
            setModel(value); 
            const foundModel = models.find(item => item.username === (value));
            if(foundModel) {
                setCampaignId(foundModel.campaign_id) 
                setModelImg((foundModel.preview_url))
            }
        }
        else if(name === "campaignId") { 
            setCampaignId(value); }
    };

    
    
    if(!tool) return <></>
    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
            <Col md={12}>
                <Card>
                <CardHeader title={tool.tool_name} description="Select a Offer to view and manage models" />
                    <Row>
                        <Col md={6} className="text-center p-4">
                            <Select
                                value={pathid}
                                label="Offer"
                                name="pathid"
                                formField="pathid"
                                formValues={paths}
                                useDefault={true}
                                onChange={handleChange} 
                                validate="required"
                                colSize="8"
                            />
                        </Col>
                        <Col sm={6}>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        {pathid > 0 && <>
        <Form title={`Cams Models for ${path}`} description="" onSubmit={updateModel}> 
        <Row>
            <Col md={6}> 
                <Card.Body>
                    <Row>
                    <Col md={4} className="control-label col-form-label">Model</Col>
                        <Col md={8} sm={8}>
                            <FormGroup>
                                <select 
                                    id="model"
                                    name="model" 
                                    value={model}
                                    className="form-control"  
                                    onChange={handleChange}>
                                    <option value="0">-- Select a Model--</option>
                                    <optgroup label="Configured">
                                        {models && models
                                        .filter(option => option.campaign_id.length > 0)
                                        .map((option, o) => (
                                            <option value={option.username} key={`conf_${o}`}>
                                            {option.username} ({option.campaign_id})
                                            </option>
                                        ))}
                                    </optgroup>

                                    <optgroup label="Unconfigured">
                                        {models && models
                                        .filter(option => option.campaign_id.length === 0)
                                        .map((option, o) => (
                                            <option value={option.username} key={`unconf_${o}`}>
                                            {option.username}
                                            </option>
                                        ))}
                                    </optgroup>
                                </select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="control-label col-form-label">Campaign ID</Col>
                        <Col md={8} sm={8}>
                            <FormControl aria-label="Campaign ID" type="text" name="campaignId" id="campaignId" onChange={handleChange} value={campaignId} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className='p-5 text-right'>
                            {modelImg && <img src={cleanUrl(modelImg)} alt={model} /> }
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="text-center">
                            <Card.Text>{formMessage ?? ""}</Card.Text>
                            {!updating ? <Button title="Update Model" className="primary" /> : null}
                        </Col>
                    </Row>

                </Card.Body>
            </Col>
            <Col md={6}> 
                    <DataTable tableID={tableID} fieldNames={tableFields} hideTotal={true} dataRows={tableData()} tableSettings={tableTypes.None} onClick={viewModel} hover={true} />
                    <Row>
                        <Col md={12} className="text-center"><Button onClick={addModel} title="Configure New Model" className="primary" /></Col>
                    </Row>
            </Col>
        </Row>
        </Form>
        </> }
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(CamModelManagement), "Cams Models Management"));